import type { AssetCapabilities } from "@/api/library";
import { Badge } from "@/ui/Badge";

/**
 * The asset's editorial state, straight from the server-derived capabilities.
 *
 * The states are not mutually exclusive — the locked safety floor is also
 * seeded — so this renders every flag that is set rather than electing one.
 * "Editable" appears only when no restricting flag applies, so a row with no
 * badge cannot be mistaken for one whose state failed to load.
 */
export function AssetStateBadges({
  capabilities,
}: {
  capabilities: AssetCapabilities;
}) {
  const restricted =
    capabilities.seeded || capabilities.lockedFloor || capabilities.archived;

  return (
    <span className="flex flex-wrap items-center gap-1">
      {capabilities.seeded ? <Badge tone="accent">Seeded</Badge> : null}
      {capabilities.lockedFloor ? (
        <Badge tone="warning">Locked floor</Badge>
      ) : null}
      {capabilities.archived ? <Badge tone="outline">Archived</Badge> : null}
      {restricted ? null : <Badge tone="success">Editable</Badge>}
    </span>
  );
}
